<template>
  <div>
    <h2 class="auth-heading">E-mail Verification Required</h2>
    <v-card-text>


      <p>Your account requires periodic e-mail verification to continue using your account. </p>

      <p>You should have received an e-mail with a link to verify your account. If you have not received the e-mail please click below to resend</p>
    </v-card-text>

    <v-card-actions>

      <v-btn class="center-button" :disabled="resend" color="primary" type="submit" @click="resendVerification">Send Verification E-mail</v-btn>

    </v-card-actions>
  </div>
</template>

<script>
import {recaptcha} from "@/mixins/captcha";

export default {
  name: "ValidateEmail",
  mixins: [recaptcha],
  data: () => ({
    resend: false
  }),
  methods: {
    async resendVerification() {

      await this.$store.dispatch("loader/loaderInitiate", { title: "Resending Verification E-mail" });

      const captcha = await this.recaptchaToken();

      const result = await this.$store.dispatch("auth/verificationResend", { captcha: captcha });

      await this.$store.dispatch("loader/loaderCancel");

      if (result) {
        this.resend = true;
        await this.$store.dispatch("notification/triggerSuccess", { detail: "You should receive your e-mail shortly", title: "Successfully sent" });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  text-align: center;
}

.auth-heading {
  text-transform: none !important;
  background-color: #5d3791;
  color: white !important;
  padding: 15px 10px;
}
</style>
